import {RootState} from 'store'
import {MetaState} from 'types/State'
import {
  getLandingTrafficSourceFromUrl,
  getLandingUtmReferrerFromUrl
} from 'utils/trafficSource'

import {
  getOrGenerateAnonymousId,
  persistAnonymousId
} from '@vio/core/src/_web/anonymousId'
import {
  getBrandCodeFromUrlOrCookie,
  getSubBrandKeyFromUrl
} from '@vio/core/src/_web/brand/utils'
import {
  getFirstVisit,
  persistFirstVisit
} from '@vio/core/src/_web/userConfig/userFirstVisit'
import {
  getVisitsCount,
  persistVisitsCount
} from '@vio/core/src/_web/userConfig/visitsCount'
import {getUrlParams} from '@vio/core/src/_web/utils/url'
import {getUserDeviceDetails} from '@vio/core/src/_web/utils/userAgent/device'
// eslint-disable-next-line @vio/custom-rules/prefer-usebrand-hook -- Needed for augmentMetaState to get brand object from brandCode for subBrand resolution
import {getBrandByCode} from '@vio/core/src/brand/config'

import {initialState as defaultState} from './slice'
import {determineIsReturningUser} from './utils'
/**
 * Augment initial meta with client side props
 */
export const augmentMetaState = (
  initialState: Partial<RootState>
): MetaState => {
  const initialMeta = initialState?.meta || ({} as Partial<MetaState>)
  const {devicePlatform, deviceCategory, userAgentDetails} =
    getUserDeviceDetails()

  const anonymousId = getOrGenerateAnonymousId()
  persistAnonymousId(anonymousId)
  persistVisitsCount()
  persistFirstVisit()
  const firstVisit = getFirstVisit()
  const isReturningUser = determineIsReturningUser(firstVisit)
  const visitsCount = getVisitsCount()
  const trafficSource = getLandingTrafficSourceFromUrl(
    initialState as RootState
  )
  const utmReferrer = getLandingUtmReferrerFromUrl(initialState as RootState)
  const env = process.env.NEXT_PUBLIC_ENV
  const brandCode = getBrandCodeFromUrlOrCookie(env)
  const brand = getBrandByCode(brandCode)
  const subBrand = getSubBrandKeyFromUrl(brand)
  const {deviceId} = getUrlParams() as {
    deviceId: MetaState['deviceId']
  }

  const state: MetaState = {
    ...defaultState,
    devicePlatform,
    deviceCategory,
    userAgentDetails,
    trafficSource,
    utmReferrer,
    brandCode,
    subBrand,
    anonymousId,
    isReturningUser,
    firstVisit,
    visitsCount,
    deviceId,
    // Allow tests to overwrite initial state
    ...initialMeta,
    // UA string is not available server-side for cached pages, so recalculate
    ...(initialMeta.devicePlatform === 'unknown'
      ? {
          devicePlatform,
          deviceCategory,
          userAgentDetails
        }
      : {})
  }
  return state
}

export {default} from './slice'
